import React from 'react'

const EnableFunctionality = () => {
  return (
    <div
      style={{
        marginRight: 'auto',
        marginLeft: 'auto',
      }}
    >
      Contact{' '}
      <a href='mailto:info@ordersmadesimple.com'>info@ordersmadesimple.com</a>{' '}
      to turn this on.
    </div>
  )
}

export default EnableFunctionality
